export const doctor={
	"jpzlist":[{
			"name":'贾培增',
			"headerImg":require('../image/doctor/jpz.jpg'),
			"xzBool":false
		},{
			"name":'宋虹',
			"headerImg":require('../image/doctor/sh.jpg'),
			"xzBool":false
		},{
			"name":'刘思',
			"headerImg":require('../image/doctor/ls.jpg'),
			"xzBool":false
		},{
			"name":'刘晓濛',
			"headerImg":require('../image/doctor/lxm.jpg'),
			"xzBool":false
		},{
			"name":'李晓红',
			"headerImg":require('../image/doctor/lxh.jpg'),
			"xzBool":false
		}],
	"jpztd":[{
		"name":'贾培增',
		"headerImg":require('../image/doctor/jpz.jpg'),
		"xzBool":false,
		"type":1,
		"childen":[{
			"name":'刘晓濛',
			"headerImg":require('../image/doctor/lxm.jpg'),
			"xzBool":false
		}]
	},{
		"name":'宋虹',
		"headerImg":require('../image/doctor/sh.jpg'),
		"xzBool":false,
		"type":2,
		"childen":[{
			"name":'李晓红',
			"headerImg":require('../image/doctor/lxh.jpg'),
			"xzBool":false
		}]
	},{
		"name":'刘思',
		"headerImg":require('../image/doctor/ls.jpg'),
		"xzBool":false,
		"type":2,
		
	}],
	"wxdlist":[{
		"name":'王雪东',
		"headerImg":require('../image/doctor/wxd.jpg'),
		"xzBool":false
	},{
		"name":'吴冠慧',
		"headerImg":require('../image/doctor/wgh.jpg'),
		"xzBool":false
	},{
		"name":'李琳',
		"headerImg":require('../image/doctor/ll.jpg'),
		"xzBool":false
	}],
	"wxdtd":[{
		"name":'王雪东',
		"headerImg":require('../image/doctor/wxd.jpg'),
		"xzBool":false,
		"type":1,
		"childen":[{
			"name":'李琳',
			"headerImg":require('../image/doctor/ll.jpg'),
			"xzBool":false
		}]
	},{
		"name":'吴冠慧',
		"headerImg":require('../image/doctor/wgh.jpg'),
		"xzBool":false,
		"type":2,
	}]
	
}


// WEBPACK FOOTER //
// ./src/assets/js/doctor.js